
class Locale
{
	constructor(localeName)
	{
		this.fallbackLocaleName = localeName;
		this.currentLocaleName = localeName;
		this.dictionary = {};

		if (localeName) {
			this.setLocale(localeName);
		}
	}

	registerLocale(name)
	{
		if (this.dictionary[name]) {
			return true;
		}

		try {
			this.dictionary[name] = require(`./${name}.json`);
		} catch (e) {
			return false;
		}

		return true;
	}

	setLocale(localeName)
	{

		if (!this.dictionary.hasOwnProperty(this.currentLocaleName)) {
			if (!this.registerLocale(this.currentLocaleName)) {
				return false;
			}
		}

		this.currentLocaleName = localeName;

		return true;
	}

	isLocaleRegistered(localeName)
	{
		return this.dictionary.hasOwnProperty(localeName);
	}

	setLocaleDetected(defaultLocaleName)
	{
		const locales = [];

		const match = location.search.match(/[?&]lang=(\w{2,3})/);
		if (match) {
			locales.push(match[1]);
		}

		const navigatorLocales = (navigator.languages || [navigator.language]).map((name) => name.split('-')[0]);
		locales.push(...navigatorLocales);

		const localeName = locales.find((localeName) => this.isLocaleRegistered(localeName));
		this.setLocale(localeName || defaultLocaleName);
	}

	get(name, params)
	{
		params = params || {};

		let text = this.dictionary[this.currentLocaleName][name] || this.dictionary[this.fallbackLocaleName][name] || '';

		text = text.replace(/{([-_\w\d]+)}/gi, (found, parameterName) => params[parameterName] || '');

		return text;
	}

	getProperty(source, name, params)
	{
		const getPossibleKeys = (localeName) => {
			return [
				name + localeName.substr(0, 1).toUpperCase() + localeName.substr(1),
				name + '_' + localeName,
				localeName + '_' + name,
			];
		};

		if (!source) {
			return '';
		}

		params = params || {};

		const possibleKeys = [];
		possibleKeys.push(...getPossibleKeys(this.currentLocaleName));
		if (this.currentLocaleName === 'ru' || this.fallbackLocaleName === 'ru') {
			possibleKeys.push(name);
		}
		if (this.currentLocaleName !== this.fallbackLocaleName) {
			possibleKeys.push(...getPossibleKeys(this.fallbackLocaleName));
		}

		const existName = possibleKeys.find((key) => !!source[key]);

		let text = existName ? source[existName] : '';

		text = text.replace(/{([-_\w\d]+)}/gi, (found, parameterName) => params[parameterName] || '');

		return text;
	}
}


const locale = new Locale('ru');
locale.registerLocale('ru');
locale.registerLocale('en');
locale.setLocaleDetected('ru');


export default locale;
